import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import NavCircle from './NavCircle';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const [hoveredSection, setHoveredSection] = useState(null);

  const getActiveSection = () => {
    if (currentPath.startsWith('/industrial')) {
      return 'industrial';
    }
    return 'household';
  };

  const activeSection = getActiveSection();

  const handleSectionChange = (newSection) => {
    if (newSection === activeSection) return;
    navigate(`/${newSection}`);
  };

  return (
    <>
      {/* <NavCircle /> */}
      <motion.nav 
        className="bg-white shadow-[0_8px_16px_rgba(0,0,0,0.3)]"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ 
          y: { type: "spring", stiffness: 300, damping: 30 },
          opacity: { duration: 0.4 }
        }}
      >
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center md:justify-end h-14 md:h-12">
            {/* Section Toggle */}
            <div className="flex space-x-8">
              <motion.button
                onClick={() => handleSectionChange('household')}
                className="relative inline-flex items-center px-2 md:px-1 pt-1 text-xl md:text-lg font-medium"
                onMouseEnter={() => setHoveredSection('household')}
                onMouseLeave={() => setHoveredSection(null)}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ 
                  delay: 0.3,
                  x: { type: "spring", stiffness: 300, damping: 30 },
                  opacity: { duration: 0.4 }
                }}
              >
                <motion.span
                  className={`uppercase tracking-wider ${
                    activeSection === 'household' ? 'text-[#D3242A]' : 'text-gray-500'
                  }`}
                  style={{ 
                    fontFamily: "Geogrotesque, sans-serif",
                    fontWeight: "bold",
                    fontStyle: "italic"
                  }}
                  animate={{
                    scale: activeSection === 'household' ? 1.1 : hoveredSection === 'household' ? 1.05 : 1,
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 20
                  }}
                >
                  Household
                </motion.span>
              </motion.button>
              <motion.button
                onClick={() => handleSectionChange('industrial')}
                className="relative inline-flex items-center px-2 md:px-1 pt-1 text-xl md:text-lg font-medium"
                onMouseEnter={() => setHoveredSection('industrial')}
                onMouseLeave={() => setHoveredSection(null)}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ 
                  delay: 0.5,
                  x: { type: "spring", stiffness: 300, damping: 30 },
                  opacity: { duration: 0.4 }
                }}
              >
                <motion.span
                  className={`uppercase tracking-wider ${
                    activeSection === 'industrial' ? 'text-[#D3242A]' : 'text-gray-500'
                  }`}
                  style={{ 
                    fontFamily: "Geogrotesque, sans-serif",
                    fontWeight: "bold",
                    fontStyle: "italic"
                  }}
                  animate={{
                    scale: activeSection === 'industrial' ? 1.1 : hoveredSection === 'industrial' ? 1.05 : 1,
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 20
                  }}
                >
                  Industrial
                </motion.span>
              </motion.button>
            </div>
          </div>
        </div>
      </motion.nav>
    </>
  );
};

export default Navbar; 